import { render, staticRenderFns } from "./CreateEditAgreements.vue?vue&type=template&id=0f2130df&scoped=true&"
import script from "./CreateEditAgreements.vue?vue&type=script&lang=js&"
export * from "./CreateEditAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2130df",
  null
  
)

export default component.exports